import MyModal from './MyModal';

export default MyModal;
